import { COMMON_LABELS } from "../default-constants";

// 審査内容照会のラベル
export const LABELS = {
  EXAMINATION_RESULT_HANDLING: "審査結果取扱",
  CONTENTS_CHECK_SHEET: "コンテンツチェックシート",
  EXAMINATION_APPLICATION_NO: "審査申請No",
  APPLICATION_NO: "申請No",
  APPLICATION_DATE: "申請日",
  APPLICATION_MANAGER: "申請担当",
  APPLICATION_TYPE: "申請種別",
  EXAMINATION_TYPE: "審査種別",
  REGISTER_NAME: "親事業者",
  COMPANY_NAME: "事業者",
  BUSINESS_STYLE: "事業形態",
  CORPORATE_NUMBER: "法人番号",
  MERCHANT_NAME: "加盟店名",
  EXAMINATION_COMPREHENSIVE_STATUS: "総合審査結果",
  EXAMINATION_ORDER_TARGET: "審査依頼先",
  EXAMINATION_ORDER_DATE: "審査依頼日",
  EXAMINATION_ANSWER_DATE: "審査回答日",
  EXAMINATION_STATUS: "審査状況",
  POS_REGISTRATION_ORDER_DATE: "POS登録依頼日",
  POS_REGISTRATION_ANSWER_DATE: "POS登録回答日",
  POS_REGISTRATION_STATUS: "POS登録状況",
  MERCHANT_NO: "加盟店番号／決済グループID",
  TENANT_MERCHANT_NO: "加盟店番号（店子）／決済グループID",
  ACCESS_KEY: "Access Key",
  SECRET_KEY: "Secret Key",
  DOCOMO: "ドコモ",
  V_M_TF: "V/M（TF）",
  V_M_SMCC: "V/M（SMCC）",
  V_M_SAISON: "V/M（セゾン）",
  JCB: "JCB",
  AMEX: "AMEX",
  NTT_F: "NTT-F",
  GMO_PG: "GMOPG",
  NTTDATA_V_M: "NTTデータ（V/M）",
  NTTDATA_JCB: "NTTデータ（JCB）",
  NTTDATA_AMEX: "NTTデータ（AMEX）",
  RE_EXAMINATION_INSTRUCTION_JUDGEMENT: "再審査指示・判定",
  EXAMINATION_WAITING: "承認待ち",
  EXAMINATION_COMPREHENSIVE_WAITING: "総合審査待ち",
  EXAMINATION_NG: "NG（承認済）",
  EXAMINATION_OK: "OK（承認済）",
  DOT: "●",
  RELATED_EXAMINATION: "関連審査",
  RELATED_TITLE: "関連審査一覧",
};
// 審査依頼先 V/M
export const EXAMINATION_ORDER_TARGET = [
  "V/M（SMCC）",
  "V/M（TF）",
  "V/M（セゾン）",
];
// 審査申請区分 月次定クレ
export const EXAMINATION_APPLICATION_MONTHLY_PERIODIC_CREDIT = 2;
// 審査区分 変更審査
export const EXAMINATION_TYPE_CHANGE = "変更審査";
//審査種別: 店舗
export const APPLICATION_TYPE_STORES = [12, 22, 16];
//決済先区分 Omni
export const SETTLEMENT_TARGET_KUBUN = 2;
//審査ステータス 実施不要
export const EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT = 399;
// 審査依頼先テーブルIF
export interface IExaminationTargetItems {
  examinationOrderTarget: string;
  vMTarget?: boolean;
  examinationOrderDate: string;
  examinationAnswerDate: string;
  examinationStatus: string;
  posRegistrationOrderDate: string;
  posRegistrationAnswerDate: string;
  posRegistrationStatus: string;
  merchantNo: string;
  tenantMerchantNo: string;
  accessKey: string;
  secretKey: string;
}
// 事業形態
const BUSINESS_STYLE: { [key: string]: string } = {
  "1": "法人",
  "2": "個人",
};
// ステータスIF
interface IStatusObj {
  code: number;
  label: string;
}
// 総合審査結果
interface IExaminationComprehensiveStatus {
  examinationWaiting: IStatusObj;
  examinationComprehensiveWaiting: IStatusObj;
  examinationNg: IStatusObj;
  examinationOk: IStatusObj;
}
const EXAMINATION_COMPREHENSIVE_STATUS: IExaminationComprehensiveStatus = {
  examinationComprehensiveWaiting: {
    code: 101,
    label: LABELS.EXAMINATION_COMPREHENSIVE_WAITING,
  },
  examinationWaiting: {
    code: 102,
    label: LABELS.EXAMINATION_WAITING,
  },
  examinationNg: {
    code: 201,
    label: LABELS.EXAMINATION_NG,
  },
  examinationOk: {
    code: 301,
    label: LABELS.EXAMINATION_OK,
  },
};

// 審査状況ステータス
const CREDIT_EXAMINATION_STATUS: { [key: number]: string } = {
  101: "依頼送付待ち",
  102: "依頼済み",
  103: "ダウンロード待ち",
  201: "審査NG",
  301: "審査OK",
  399: "ー",
};
// POS登録状況ステータス
const POS_REGISTRATION_STATUS: { [key: number]: string } = {
  301: "完了",
  399: COMMON_LABELS.HYPHEN,
};

/**
 * 引数の総合審査結果コードを基に画面表示用のラベルを返却する.
 * @param {number} statusCode 総合審査結果コード
 * @returns {string}  総合審査結果ラベル
 */
export const getExaminationComprehensiveStatusLabel = (statusCode: number) => {
  const {
    examinationWaiting,
    examinationComprehensiveWaiting,
    examinationNg,
    examinationOk,
  } = EXAMINATION_COMPREHENSIVE_STATUS;
  // 総合審査結果101であれば総合審査待ち
  if (statusCode === examinationComprehensiveWaiting.code) {
    return examinationComprehensiveWaiting.label;
    // 総合審査結果102であれば承認待ち
  } else if (statusCode === examinationWaiting.code) {
    return examinationWaiting.label;
  } else if (statusCode === examinationNg.code) {
    return examinationNg.label;
  } else if (statusCode === examinationOk.code) {
    return examinationOk.label;
  } else {
    return COMMON_LABELS.BLANK;
  }
};

/**
 * 引数の事業形態コードを基に画面表示用のラベルを返却する.
 * @param {string} BusinessStyleCode 事業形態コード
 * @return {string} 事業形態ラベル
 */
export const getBusinessStyleLabel = (BusinessStyleCode: string) =>
  BUSINESS_STYLE[BusinessStyleCode] ?? COMMON_LABELS.BLANK;

/**
 * 引数の審査状況ステータスコードを基に画面表示用のラベルを返却する.
 * @param {number} examinationStatusCode 審査状況ステータスコード
 * @returns {string} 審査状況ステータスラベル
 */
export const getExaminationStatusLabel = (examinationStatusCode: number) =>
  CREDIT_EXAMINATION_STATUS[examinationStatusCode] ?? COMMON_LABELS.BLANK;

/**
 * 引数のPOS登録状況ステータスコードを基に画面表示用のラベルを返却する.
 * @param {number} posRegisterStatus POS登録状況ステータスコード
 * @returns {string} POS登録状況ステータスラベル
 */
export const getPosRegistrationStatusLabel = (posRegisterStatus: number) =>
  POS_REGISTRATION_STATUS[posRegisterStatus] ?? COMMON_LABELS.BLANK;

/**
 * 引数の審査状況ステータスコードを基に月次定クレの画面表示用のラベルを返却する.
 * @param {number} examinationStatusCode 審査状況ステータスコード
 * @returns {string} 審査状況ステータスラベル
 */
export const getExaminationStatusLabelMonthlyPeriodicCredit = (
  examinationStatusCode: number,
  examinationComprehensiveStatus: number
) => {
  const { examinationOk } = EXAMINATION_COMPREHENSIVE_STATUS;
  if (examinationComprehensiveStatus === examinationOk.code) {
    return (
      CREDIT_EXAMINATION_STATUS[examinationStatusCode] ?? COMMON_LABELS.BLANK
    );
  } else {
    return examinationStatusCode === 101
      ? COMMON_LABELS.BLANK
      : CREDIT_EXAMINATION_STATUS[examinationStatusCode] ?? COMMON_LABELS.BLANK;
  }
};

/**
 * 引数の審査申請No（関連審査）と審査種別（関連審査）を一覧表示用に加工し返却する。
 * @param {string[]} relatedExaminationApplicationNo 審査申請No（関連審査）
 * @param {string[]} relatedExaminationTypeList 審査種別（関連審査）
 * @returns {IRelatedExaminationTargetItems[]} 関連審査用データ
 */
export const getRelatedExamination = (
  relatedExaminationApplicationNo: string[],
  relatedExaminationTypeList: string[]
) => {
  if (
    relatedExaminationApplicationNo !== null &&
    relatedExaminationApplicationNo.length !== 0
  ) {
  }
};
